var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSpotifyLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_2",
    "data-name": "Layer 2",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 533.33 533.33",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #000;\n        stroke-width: 0px;\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m424.41,236.41c-85.96-51.05-227.74-55.74-309.8-30.84-13.18,4-27.11-3.44-31.1-16.62-3.99-13.19,3.44-27.11,16.62-31.12,94.2-28.59,250.78-23.07,349.74,35.67,11.86,7.04,15.74,22.34,8.71,34.18-7.03,11.85-22.35,15.76-34.18,8.72m-2.81,75.61c-6.03,9.79-18.83,12.86-28.6,6.85-71.66-44.05-180.94-56.81-265.72-31.08-10.99,3.32-22.61-2.88-25.95-13.85-3.31-10.99,2.89-22.58,13.86-25.93,96.85-29.39,217.25-15.16,299.56,35.42,9.77,6.02,12.85,18.82,6.84,28.58m-32.63,72.61c-4.77,7.83-14.99,10.32-22.82,5.55-.01,0-.02-.01-.03-.02-62.62-38.27-141.44-46.91-234.26-25.71-8.94,2.05-17.85-3.55-19.9-12.49,0,0,0,0,0,0-2.05-8.93,3.52-17.84,12.46-19.89.01,0,.03,0,.04,0,101.58-23.22,188.71-13.23,259,29.72,7.83,4.79,10.31,15.02,5.52,22.85,0,0,0,0,0,0M266.66,0C119.39,0,0,119.39,0,266.66s119.39,266.67,266.66,266.67,266.67-119.38,266.67-266.67S413.94,0,266.66,0"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSpotifyLogo);
export default __webpack_public_path__ + "static/media/spotifyLogo.7d2d734b71bc22ed02b2b25991debe65.svg";
export { ForwardRef as ReactComponent };